import Axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "react-i18next";
import lock from "../../../../assets/images/user/lock.png";
import { useNotification } from "../../../../contexts/NotificationContext";

export const ResetPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const { email } = useParams();
  const [loading, setLoading] = useState(false);
  const { notify } = useNotification();

  const passwordValidation = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*]/.test(password);

    if (password.trim().length < minLength) {
      notify(t("auth.resetPassword.minLengthError"), {
        type: "warning",
      });
      return false;
    }
    if (!hasUpperCase) {
      notify(t("auth.resetPassword.uppercaseError"), {
        type: "warning",
      });
      return false;
    }
    if (!hasLowerCase) {
      notify(t("auth.resetPassword.lowercaseError"), {
        type: "warning",
      });
      return false;
    }
    if (!hasNumber) {
      notify(t("auth.resetPassword.numberError"), {
        type: "warning",
      });
      return false;
    }
    if (!hasSpecialChar) {
      notify(t("auth.resetPassword.specialCharError"), {
        type: "warning",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !passwordValidation(newPassword) ||
      newPassword !== confirmNewPassword
    ) {
      if (newPassword !== confirmNewPassword) {
        notify(t("auth.resetPassword.passwordMismatchError"), {
          type: "warning",
        });
      }
      return;
    }

    setLoading(true);
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/Auth/NewPassword`,
        { user: email, password: password, newPassword: newPassword },
      );

      if (res.status === 200) {
        if (res.data.message === "") {
          notify(t("auth.resetPassword.successMessage"), { type: "success" });
          navigate("/");
        } else {
          window.open(res.data.message, "_blank");
          navigate("/");
        }
      } else {
        notify(t("auth.resetPassword.changeError"), { type: "warning" });
      }
    } catch (err) {
      const errorMessage =
        err.code === "ERR_BAD_REQUEST"
          ? t("auth.resetPassword.invalidUserDataError")
          : t("common.unknownError");
      notify(errorMessage, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!email) {
      navigate("/");
    } else {
    }
  }, [email, navigate]);

  return (
    <Fragment>
      <div className="auth-wrapper">
        <div className="auth-content subscribe">
          <div className="card">
            <div className="row no-gutters">
              <div className="col-md-4 col-lg-6 d-none d-md-flex d-lg-flex theme-bg align-items-center justify-content-center">
                <img src={lock} alt="lock images" className="img-fluid" />
              </div>
              <div className="col-md-8 col-lg-6">
                <div className="card-body text-center">
                  <div className="row justify-content-center">
                    <div className="col-sm-10">
                      <Form onSubmit={handleSubmit}>
                        <h3 className="mb-4">
                          {t("auth.resetPassword.pageTitle")}
                        </h3>
                        <div className="input-group mb-3">
                          <input
                            type="password"
                            className="form-control"
                            placeholder={t(
                              "auth.resetPassword.temporaryPasswordPlaceholder",
                            )}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={loading}
                          />
                        </div>
                        <div className="input-group mb-3">
                          <input
                            type="password"
                            className="form-control"
                            placeholder={t(
                              "auth.resetPassword.newPasswordPlaceholder",
                            )}
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            disabled={loading}
                          />
                        </div>
                        <div className="input-group mb-4">
                          <input
                            type="password"
                            className="form-control"
                            placeholder={t(
                              "auth.resetPassword.confirmPasswordPlaceholder",
                            )}
                            value={confirmNewPassword}
                            onChange={(e) =>
                              setConfirmNewPassword(e.target.value)
                            }
                            disabled={loading}
                          />
                        </div>
                        <div className="password-requirements">
                          <span>
                            - {t("auth.resetPassword.requirements.minLength")}
                          </span>
                          <span>
                            - {t("auth.resetPassword.requirements.uppercase")}
                          </span>
                          <span>
                            - {t("auth.resetPassword.requirements.lowercase")}
                          </span>
                          <span>
                            - {t("auth.resetPassword.requirements.number")}
                          </span>
                          <span>
                            - {t("auth.resetPassword.requirements.specialChar")}
                          </span>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary shadow-2 mb-4"
                          disabled={loading}
                          style={{ marginTop: "15px" }}
                        >
                          {loading ? (
                            <ClipLoader size={20} color={"#ffffff"} />
                          ) : (
                            t("auth.resetPassword.submitButton")
                          )}
                        </button>
                        <p className="mb-2 text-muted">
                          <Link to="/">
                            {t("auth.resetPassword.backToLogin")}
                          </Link>
                        </p>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
